export default {
  "hero.title_line1": "海量韩漫",
  "hero.title_line2": "免费畅读",
  "hero.subtitle": "全网最全韩国漫画平台，每日更新热门作品，支持多语言翻译与个性化推荐，沉浸式阅读体验触手可及",
  "hero.cta": "立即开始阅读",
  "hero.badge": "🔥 每日更新 200+ 话",

  "feature.title": "🔥 本周热门推荐",
  "feature.subtitle": "大家都在追的韩漫",

  "stats.works": "覆盖作品",
  "stats.users": "全球用户",
  "stats.daily": "日更新量",
  "stats.languages": "支持语言",

  "grid.title_sub": "精选分类",
  "grid.title_main": "探索你的漫画世界",
  "grid.desc": "从甜蜜恋爱到热血动作，从悬疑推理到奇幻冒险——我们为你精心整理了最受欢迎的漫画分类，每一部作品都经过编辑团队层层筛选，确保品质与精彩并存。",

  "testimonial.quote": "这个平台的漫画资源真的太全了！我追的几部冷门韩漫都能在这里找到，而且更新速度超快，画质也特别清晰。每天通勤路上看几话，已经成为我生活中不可或缺的一部分。",
  "testimonial.name": "小樱花",
  "testimonial.role": "资深漫迷 · 3年老用户",

  "faq.title": "常见问题",
  "faq.q1": "在线漫画韩漫是免费的吗？",
  "faq.a1": "是的！我们平台上的所有漫画作品均可免费阅读，无需付费订阅。我们通过广告和品牌合作维持运营，始终致力于为漫迷提供无障碍的阅读体验。",
  "faq.q2": "平台有多少部韩漫作品？",
  "faq.a2": "目前平台收录超过 10,000 部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑、耽美等 20+ 个分类，并且每天都在持续扩充中。",
  "faq.q3": "支持哪些语言阅读？",
  "faq.a3": "我们支持简体中文、繁体中文、英语、日语、韩语、泰语等 15 种语言。AI 翻译引擎持续优化，确保多语言阅读质量。",
  "faq.q4": "漫画更新频率是怎样的？",
  "faq.a4": "热门连载作品通常每周更新 1-2 话，平台每日新增 200+ 话内容。您可以在个人中心订阅喜欢的作品，更新时第一时间收到通知。",
  "faq.q5": "如何在手机上阅读？",
  "faq.a5": "我们的网站已全面适配移动端，打开浏览器访问即可获得流畅的手机阅读体验。同时支持横屏/竖屏切换，满足不同阅读习惯。",
};